export enum BrokerStatus {
  Inactive = 0,
  Active = 1,
  Pending = 3,
  /**
   * Cadastro feito pelo link de lead, aguardando o parceiro assinar o Termo de Parceria na
   * ClickSign. Só o sistema (webhook da assinatura) tira o parceiro daqui, levando a Pendente —
   * por isso não é uma opção selecionável no cadastro.
   */
  WaitingSignature = 4,
}
